import React, { createContext, useContext, useState, useMemo } from 'react'

const FormContext = createContext()

export const useFormContext = () => useContext(FormContext)

export const FormProvider = ({ children, initialFormData }) => {
  const [formData, setFormData] = useState(initialFormData || {})

  const contextValue = useMemo(
    () => ({
      formData,
      setFormData,
    }),
    [formData, setFormData]
  )

  return <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>
}
